import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-arrow-down-solid",
  "use": "icon-arrow-down-solid-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-arrow-down-solid\"><defs><style type=\"text/css\"></style></defs><path d=\"M0 307.931429l512 538.770285 512-538.843428z\" p-id=\"6185\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol